import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axiosInstance from "../../api/axiosInstance";
import { dentalMapping } from "../../utils/functions";

const COLORS = {
  gray:   '#5B6B79',
  blue:   '#96C5F7',
  red:    '#9E2B25',
  orange: '#F29E4C',
  green:  '#2CA87F',
}

const thStyle = {
  fontSize: 11, fontWeight: 700, color: COLORS.gray, textTransform: 'uppercase',
  letterSpacing: '0.05em', padding: '8px 12px', background: '#f8f9fb',
  borderBottom: '1px solid #e8ecf0', whiteSpace: 'nowrap',
}
const tdStyle = {
  fontSize: 12, color: '#2d3748', padding: '7px 12px',
  verticalAlign: 'middle', borderBottom: '1px solid #f0f2f5',
}

const Badge = ({ label, bg, color }) => (
  <span style={{
    fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10,
    background: bg || '#e8ecf0', color: color || COLORS.gray, whiteSpace: 'nowrap',
  }}>{label}</span>
)

const paginBtn = (disabled) => ({
  width: 28, height: 28, borderRadius: 6, border: `1px solid ${COLORS.blue}`,
  background: disabled ? '#f5f7fa' : COLORS.blue, color: disabled ? '#aaa' : '#fff',
  cursor: disabled ? 'not-allowed' : 'pointer', display: 'flex',
  alignItems: 'center', justifyContent: 'center', fontSize: 13,
})

const inputStyle = {
  height: 34, borderRadius: 8, border: '1px solid #dde3eb',
  padding: '0 10px', fontSize: 12, color: '#2d3748', outline: 'none', background: '#fff',
}
const labelStyle = {
  fontSize: 11, fontWeight: 700, color: COLORS.gray,
  textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 4,
}
const formInput = {
  width: '100%', height: 36, borderRadius: 8, border: '1.5px solid #dde3eb',
  padding: '0 10px', fontSize: 13, color: '#2d3748', outline: 'none', background: '#fff',
}
const formSelect = {
  ...formInput, cursor: 'pointer',
}

const overlayStyle = {
  position: 'fixed', inset: 0, zIndex: 1050,
  background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: 16,
}

export default function Service() {
  const navigate = useNavigate();
  const [filterByCategory, setFilterByCategory] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [currentPatients,  setCurrentPatients]  = useState([]);
  const [indexOfFirst,     setIndexOfFirst]      = useState(0);
  const [totalPages,       setTotalPages]        = useState(1);
  const [patients,         setPatients]          = useState([]);
  const [patients1,        setPatients1]         = useState([]);
  const [openVital121,     setOpenVital121]      = useState(false);
  const [editabledata,     setEditabledata]      = useState(false);
  const [searchTerm,       setSearchTerm]        = useState("");
  const [currentPage,      setCurrentPage]       = useState(1);
  const itemsPerPage = 10;
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId,     setEditId]     = useState(null);
  const [inpval, setInpval] = useState({
    serviceName: "", description: "", category: "", durationMinutes: "",
    standardCost: "", secondaryCost: "", insuranceCost: "", serviceCode: "",
    vat: "No", isDental: false, dentalMode: "single", dental_type: "surface",
  });
  const [vatValue,     setVatValue]     = useState(0);
  const [fieldErrors,  setFieldErrors]  = useState({ standardCost: '', secondaryCost: '', insuranceCost: '' });
  const [inventoryList,   setInventoryList]   = useState([]);
  const [linkedItems,     setLinkedItems]     = useState([]);
  const [itemSelectId,    setItemSelectId]    = useState("");
  const [itemSelectQty,   setItemSelectQty]   = useState(1);
  const [itemSearch,      setItemSearch]      = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [consentsList,       setConsentsList]       = useState([]);
  const [linkedConsentIds,   setLinkedConsentIds]   = useState([]);
  const [consentSearch,      setConsentSearch]      = useState("");

  useEffect(() => { getdata(); getdata1(); }, []);

  const getdata = async () => {
    try {
      const r = await axiosInstance.get('getServices');
      if (r.data.success) setPatients(r.data.data);
    } catch (e) { console.error(e); }
  };

  const getdata1 = async () => {
    try {
      const r = await axiosInstance.get('getAllServiceCategories');
      if (r.data.success) setPatients1(r.data.data);
    } catch (e) { console.error(e); }
  };

  const handledelete = async (id) => {
    const c = await Swal.fire({ title: "Are you sure?", icon: "warning", showCancelButton: true, confirmButtonText: "Yes, delete it!" });
    if (c.isConfirmed) {
      try { await axiosInstance.delete(`deleteService/${id}`); Swal.fire("Deleted!", "Service has been deleted.", "success"); getdata(); }
      catch { Swal.fire("Error!", "Something went wrong while deleting.", "error"); }
    }
  };

  const handlechange = (e) => {
    const { name, value } = e.target;
    setInpval({ ...inpval, [name]: value });
    if (["standardCost", "secondaryCost", "insuranceCost"].includes(name)) {
      const hasValue = String(value).trim() !== '';
      setFieldErrors(prev => ({ ...prev, [name]: hasValue && !Number.isFinite(Number(value)) ? 'Must be a valid number' : '' }));
    }
    if (name === "vat" && value === "Yes") fetchVatValue();
    if (name === "vat" && value === "No")  setVatValue(0);
  };

  const viewmoal = (item) => {
    setEditabledata(true);
    setInpval({
      serviceName: item.name, description: item.description,
      category: item.categoryId ?? item.category_id ?? item.category ?? "",
      durationMinutes: item.duration ?? item.durationMinutes ?? "",
      standardCost: item.standard_price, secondaryCost: item.secondary_price,
      insuranceCost: item.insurance_price, serviceCode: item.code,
      dental_type: item.dental_type || "surface", vat: item.vat || "No",
      isDental: item.isDental, dentalMode: item.dentalMode,
    });
    setVatValue(item.vat === "Yes" ? Number(item.vat_value) || 0 : 0);
    setEditId(item.id);
  };

  const handleEdit = (item) => {
    const isDentalBool = dentalFlag(item);
    setInpval({
      serviceName: item.name, description: item.description,
      category: item.categoryId, durationMinutes: item.duration,
      standardCost: item.standard_price, secondaryCost: item.secondary_price,
      insuranceCost: item.insurance_price, serviceCode: item.code,
      dental_type: item.dental_type || "surface", vat: item.vat || "No",
      isDental: isDentalBool, dentalMode: item.dentalMode || item.DentalMode || "single",
    });
    setVatValue(item.vat === "Yes" ? item.vat_value : 0);
    setEditId(item.id);
    setIsEditMode(true);
    setOpenVital121(true);
    setLinkedConsentIds([]); setConsentSearch("");
    fetchInventory(); fetchConsentsList();
    fetchLinkedItems(item.id); fetchLinkedConsents(item.id);
    setItemSelectId(""); setItemSelectQty(1);
  };

  useEffect(() => {
    let cat = parseInt(filterByCategory) || 0;
    let filtered = patients.filter(item =>
      item.code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.insurance_price?.toString().includes(searchTerm) ||
      item.secondary_price?.toString().includes(searchTerm) ||
      item.type?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    if (cat > 0) filtered = filtered.filter(i => (i.categoryId + "") === (filterByCategory + ""));
    setTotalPages(Math.ceil(filtered.length / itemsPerPage) || 1);
    setFilteredPatients(filtered);
    const last  = currentPage * itemsPerPage;
    const first = last - itemsPerPage;
    setIndexOfFirst(first);
    setCurrentPatients(filtered.slice(first, last));
  }, [filterByCategory, searchTerm, currentPage, patients]);

  const openAdd = () => {
    setOpenVital121(true); setIsEditMode(false); setEditId(null);
    setLinkedItems([]); setItemSelectId(""); setItemSearch(""); setItemSelectQty(1);
    setShowSuggestions(false); setLinkedConsentIds([]); setConsentSearch("");
    fetchVatValue(); fetchInventory(); fetchConsentsList();
    setInpval({ serviceName:"",description:"",category:"",durationMinutes:"",standardCost:"",secondaryCost:"",insuranceCost:"",serviceCode:"",vat:"No",isDental:false,dentalMode:"single",dental_type:"surface" });
  };

  const closeAdd = () => {
    setOpenVital121(false); setIsEditMode(false); setEditId(null);
    setLinkedItems([]); setItemSelectId(""); setItemSearch(""); setItemSelectQty(1);
    setShowSuggestions(false); setLinkedConsentIds([]); setConsentSearch("");
    setInpval({ serviceName:"",description:"",category:"",durationMinutes:"",standardCost:"",secondaryCost:"",insuranceCost:"",serviceCode:"",vat:"No",isDental:false,dentalMode:"single",dental_type:"surface" });
  };

  const handlesavevital123 = async () => {
    try {
      const required = [
        { key:'serviceCode', label:'Service Code' }, { key:'serviceName', label:'Service Name' },
        { key:'category', label:'Category' }, { key:'durationMinutes', label:'Duration' },
        { key:'standardCost', label:'Standard Cost' }, { key:'secondaryCost', label:'Secondary Cost' },
        { key:'insuranceCost', label:'Insurance Cost' },
      ];
      const missing = required.filter(f => String(inpval[f.key] ?? '').trim() === '');
      if (missing.length > 0) { Swal.fire("Validation Error", `Please fill: ${missing.map(m=>m.label).join(', ')}.`, "warning"); return; }
      if (!Number.isFinite(Number(inpval.standardCost)))  { Swal.fire("Validation Error","Standard Cost must be a valid number.","warning"); return; }
      if (!Number.isFinite(Number(inpval.secondaryCost))) { Swal.fire("Validation Error","Secondary Cost must be a valid number.","warning"); return; }
      if (!Number.isFinite(Number(inpval.insuranceCost))) { Swal.fire("Validation Error","Insurance Cost must be a valid number.","warning"); return; }
      if (!Number.isFinite(Number(inpval.durationMinutes))) { Swal.fire("Validation Error","Duration must be a valid number.","warning"); return; }

      const dataPost = {
        serviceName: inpval.serviceName, description: inpval.description,
        category: parseInt(inpval.category), durationMinutes: parseInt(inpval.durationMinutes),
        standardCost: Number(inpval.standardCost), secondaryCost: Number(inpval.secondaryCost),
        insuranceCost: Number(inpval.insuranceCost), serviceCode: inpval.serviceCode,
        vat: inpval.vat, vat_value: inpval.vat === "Yes" ? Number(vatValue) : 0,
        isDental: inpval.isDental != 0 && inpval.isDental !== false, dental_type: inpval.dental_type || "surface",
        dentalMode: String(inpval.dentalMode||"single").toLowerCase() === "multiple" ? "multiple" : "single",
      };

      let response;
      if (isEditMode) response = await axiosInstance.put(`updateService/${editId}`, dataPost);
      else            response = await axiosInstance.post('addServices', dataPost);

      if (response.status === 200 || response.status === 201) {
        const serviceId = isEditMode ? editId : response.data?.data?.id;
        if (serviceId) {
          await saveLinkedItems(serviceId);
          await saveLinkedConsents(serviceId);
        }
        closeAdd(); getdata();
        Swal.fire("Success", `Service ${isEditMode ? "updated" : "added"} successfully.`, "success");
      } else {
        Swal.fire("Error", "Unexpected server response.", "error");
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || error.message || "Something went wrong.", "error");
    }
  };

  const fetchInventory = async () => {
    try { const r = await axiosInstance.get("getDrugs"); setInventoryList(Array.isArray(r.data.data) ? r.data.data : []); }
    catch { setInventoryList([]); }
  };
  const fetchLinkedItems = async (sid) => {
    try { const r = await axiosInstance.get(`getServiceInventoryItems/${sid}`); if (r.data.success) setLinkedItems(r.data.data); }
    catch { setLinkedItems([]); }
  };
  const addLinkedItem = () => {
    if (!itemSelectId) return;
    const drug = inventoryList.find(d => d.id == itemSelectId);
    if (!drug) return;
    if (linkedItems.find(i => i.drug_id == itemSelectId)) { Swal.fire("Warning", "Item already added.", "warning"); return; }
    setLinkedItems(prev => [...prev, { drug_id: drug.id, drug_name: drug.name, unit_of_measurement: drug.unit_of_measurement, quantity_used: Number(itemSelectQty)||1 }]);
    setItemSelectId(""); setItemSearch(""); setItemSelectQty(1); setShowSuggestions(false);
  };
  const updateLinkedItemQty = (drugId, qty) => setLinkedItems(prev => prev.map(i => i.drug_id==drugId ? {...i, quantity_used: Number(qty)||1} : i));
  const removeLinkedItem    = (drugId)      => setLinkedItems(prev => prev.filter(i => i.drug_id !== drugId));
  const saveLinkedItems = async (sid) => {
    try { await axiosInstance.post("saveServiceInventoryItems", { service_id: sid, items: linkedItems.map(i => ({ drug_id: i.drug_id, quantity_used: i.quantity_used })) }); }
    catch { Swal.fire("Warning", "Service saved but linked inventory items could not be saved.", "warning"); }
  };
  const fetchConsentsList = async () => {
    try { const r = await axiosInstance.get('consentTemplates'); setConsentsList(Array.isArray(r.data?.data) ? r.data.data : []); }
    catch { setConsentsList([]); }
  };
  const fetchLinkedConsents = async (sid) => {
    try { const r = await axiosInstance.get(`getServiceConsents/${sid}`); setLinkedConsentIds(Array.isArray(r.data?.data) ? r.data.data.map(c => c.consent_id) : []); }
    catch { setLinkedConsentIds([]); }
  };
  const saveLinkedConsents = async (sid) => {
    try { await axiosInstance.post('saveServiceConsents', { service_id: sid, consent_ids: linkedConsentIds }); }
    catch { Swal.fire("Warning", "Service saved but linked consents could not be saved.", "warning"); }
  };

  const fetchVatValue = async () => {
    try {
      const r = await axiosInstance.get('getAllVat');
      const v = Array.isArray(r?.data?.data) && r.data.data.length > 0 ? Number(r.data.data[0].vat_value) : Number(r?.data?.vat_value ?? 0);
      setVatValue(Number.isFinite(v) ? v : 0);
    } catch { setVatValue(0); }
  };

  const dentalFlag = (item) => {
    const raw = item.isDental ?? item.is_dental ?? item.is_Dental;
    return raw===1||raw==="1"||raw===true||raw==="true"||raw==="Yes";
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8ecf0', overflow: 'hidden' }}>

          {/* ── Header ── */}
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #e8ecf0', display: 'flex', alignItems: 'center', gap: 10 }}>
            <button
              onClick={() => navigate(-1)}
              style={{ width:30, height:30, borderRadius:8, border:'1px solid #e8ecf0', background:'#f8f9fb', color:COLORS.gray, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, marginRight:4, flexShrink:0 }}
              onMouseEnter={e => { e.currentTarget.style.background=COLORS.blue+'22'; e.currentTarget.style.color=COLORS.blue }}
              onMouseLeave={e => { e.currentTarget.style.background='#f8f9fb'; e.currentTarget.style.color=COLORS.gray }}
            ><i className="ti ti-arrow-left" /></button>
            <div style={{ width:32, height:32, borderRadius:8, background:`${COLORS.blue}20`, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <i className="ti ti-list-check" style={{ color:COLORS.blue, fontSize:17 }} />
            </div>
            <div>
              <div style={{ fontSize:14, fontWeight:700, color:'#1a202c' }}>Service List</div>
              <div style={{ fontSize:11, color:COLORS.gray }}>Manage clinic services, pricing and categories</div>
            </div>
            <div style={{ marginLeft:'auto' }}>
              <button
                className="bgBtn btn-sm d-flex align-items-center gap-1"
                style={{ fontSize:13, padding:'6px 14px' }}
                onClick={openAdd}
              >
                <i className="ti ti-plus" style={{ fontSize:14 }} /> Add Service
              </button>
            </div>
          </div>

          {/* ── Filter Bar ── */}
          <div style={{ padding:'10px 20px', borderBottom:'1px solid #e8ecf0', background:'#fafbfc', display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
            <div style={{ position:'relative' }}>
              <i className="ti ti-search" style={{ position:'absolute', left:9, top:'50%', transform:'translateY(-50%)', color:COLORS.gray, fontSize:13, pointerEvents:'none' }} />
              <input
                type="text"
                placeholder="Search services..."
                value={searchTerm}
                onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                style={{ ...inputStyle, paddingLeft:30, width:220 }}
              />
            </div>
            <select
              value={filterByCategory}
              onChange={e => { setFilterByCategory(e.target.value); setCurrentPage(1); }}
              style={{ ...inputStyle, width:180 }}
            >
              <option value="">All Categories</option>
              {patients1.map(item => <option key={item.id} value={item.id}>{item.category_name}</option>)}
            </select>
            <span style={{ marginLeft:'auto', fontSize:11, color:COLORS.gray }}>
              {filteredPatients.length} service{filteredPatients.length !== 1 ? 's' : ''}
            </span>
          </div>

          {/* ── Table ── */}
          <div style={{ padding:'14px 20px' }}>
            <div style={{ overflowX:'auto', borderRadius:8, border:'1px solid #e8ecf0' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ ...thStyle, borderLeft:`3px solid ${COLORS.blue}` }}>#</th>
                    <th style={thStyle}>Code</th>
                    <th style={thStyle}>Service Name</th>
                    <th style={thStyle}>Category</th>
                    <th style={thStyle}>Duration</th>
                    <th style={thStyle}>Standard</th>
                    <th style={thStyle}>Secondary</th>
                    <th style={thStyle}>Insurance</th>
                    <th style={thStyle}>VAT</th>
                    <th style={thStyle}>Net Amt</th>
                    <th style={thStyle}>Dental</th>
                    <th style={{ ...thStyle, textAlign:'center' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentPatients.length === 0 ? (
                    <tr>
                      <td colSpan={12} style={{ ...tdStyle, textAlign:'center', padding:'36px 0', color:COLORS.gray }}>
                        <i className="ti ti-database-off" style={{ fontSize:28, display:'block', marginBottom:6, opacity:0.4 }} />
                        No services found
                      </td>
                    </tr>
                  ) : currentPatients.map((item, i) => {
                    const rowBg = i % 2 === 0 ? '#fff' : '#fafbfc';
                    const net = (Number(item.standard_price) + (item.vat==="Yes" ? Number(item.vat_amount) : 0)).toFixed(3);
                    const isDental = dentalFlag(item);
                    return (
                      <tr key={item.id || i}
                        style={{ background: rowBg }}
                        onMouseEnter={e => e.currentTarget.style.background=`${COLORS.blue}0d`}
                        onMouseLeave={e => e.currentTarget.style.background=rowBg}
                      >
                        <td style={{ ...tdStyle, color:COLORS.gray, fontSize:11 }}>{indexOfFirst + i + 1}</td>
                        <td style={tdStyle}><code style={{ fontSize:11, background:'#f4f4f8', padding:'1px 5px', borderRadius:4, color:'#555' }}>{item.code}</code></td>
                        <td style={{ ...tdStyle, fontWeight:600 }}>{item.name}</td>
                        <td style={tdStyle}>
                          {item.categoryName ? <Badge label={item.categoryName} bg={`${COLORS.blue}22`} color="#1565c0" /> : <span style={{ color:'#ccc' }}>—</span>}
                        </td>
                        <td style={tdStyle}>{item.duration ? `${item.duration} min` : '—'}</td>
                        <td style={{ ...tdStyle, fontWeight:600 }}>{item.standard_price}</td>
                        <td style={tdStyle}>{item.secondary_price}</td>
                        <td style={tdStyle}>{item.insurance_price}</td>
                        <td style={tdStyle}>
                          {item.vat==="Yes"
                            ? <Badge label={`${item.vat_value}%`} bg="#fef9c3" color="#854d0e" />
                            : <span style={{ color:'#ccc' }}>—</span>}
                        </td>
                        <td style={{ ...tdStyle, fontWeight:700, color:COLORS.green }}>{net}</td>
                        <td style={tdStyle}>
                          {isDental
                            ? <Badge label={dentalMapping[item.dental_type] || 'Dental'} bg={`${COLORS.orange}20`} color={COLORS.orange} />
                            : <span style={{ color:'#ccc' }}>—</span>}
                        </td>
                        <td style={{ ...tdStyle, textAlign:'center' }}>
                          <div style={{ display:'flex', gap:5, justifyContent:'center' }}>
                            <ActionBtn icon="ti-eye"  color={COLORS.blue}  title="View"   onClick={() => viewmoal(item)} />
                            <ActionBtn icon="ti-edit" color={COLORS.green} title="Edit"   onClick={() => handleEdit(item)} />
                            <ActionBtn icon="ti-trash" color={COLORS.red}  title="Delete" onClick={() => handledelete(item.id)} />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={{ display:'flex', alignItems:'center', justifyContent:'flex-end', marginTop:12, gap:6 }}>
                <button disabled={currentPage<=1} onClick={() => setCurrentPage(p=>Math.max(p-1,1))} style={paginBtn(currentPage<=1)}>
                  <i className="ti ti-chevron-left" />
                </button>
                <span style={{ fontSize:12, color:COLORS.gray, fontWeight:600 }}>{currentPage} / {totalPages}</span>
                <button disabled={currentPage>=totalPages} onClick={() => setCurrentPage(p=>Math.min(p+1,totalPages))} style={paginBtn(currentPage>=totalPages)}>
                  <i className="ti ti-chevron-right" />
                </button>
              </div>
            )}
          </div>
        </div>

        {/* ── View Modal ── */}
        {editabledata && (
          <div style={overlayStyle} onClick={() => setEditabledata(false)}>
            <div style={{ background:'#fff', borderRadius:12, width:'min(620px,96vw)', maxHeight:'90vh', overflowY:'auto', boxShadow:'0 8px 32px rgba(0,0,0,0.18)' }} onClick={e=>e.stopPropagation()}>
              <ModalHeader icon="ti-eye" color={COLORS.blue} title="View Service" subtitle={inpval.serviceName} onClose={() => setEditabledata(false)} />
              <div style={{ padding:'0 24px 24px' }}>
                <ViewGrid label="Service Code"  value={inpval.serviceCode} />
                <ViewGrid label="Service Name"  value={inpval.serviceName} />
                <ViewGrid label="Description"   value={inpval.description} />
                <ViewGrid label="Category"      value={patients1.find(c=>c.id==inpval.category)?.category_name || inpval.category} />
                <ViewGrid label="Duration"      value={inpval.durationMinutes ? `${inpval.durationMinutes} min` : '—'} />
                <ViewGrid label="Standard Cost" value={inpval.standardCost} />
                <ViewGrid label="Secondary Cost" value={inpval.secondaryCost} />
                <ViewGrid label="Insurance Cost" value={inpval.insuranceCost} />
                <ViewGrid label="VAT"           value={inpval.vat === "Yes" ? `Yes (${vatValue}%)` : 'No'} />
                <ViewGrid label="Dental"        value={inpval.isDental ? 'Yes' : 'No'} />
                {inpval.isDental != 0 && <>
                  <ViewGrid label="Dental Mode" value={inpval.dentalMode} />
                  <ViewGrid label="Dental Type" value={dentalMapping[inpval.dental_type]} />
                </>}
                <div style={{ display:'flex', justifyContent:'flex-end', marginTop:16 }}>
                  <button onClick={() => setEditabledata(false)} style={{ padding:'7px 20px', fontSize:13, borderRadius:8, border:'1px solid #dde3eb', background:'#f8f9fb', color:COLORS.gray, cursor:'pointer' }}>Close</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Add / Edit Modal ── */}
        {openVital121 && (
          <div style={overlayStyle} onClick={closeAdd}>
            <div style={{ background:'#fff', borderRadius:12, width:'min(900px,96vw)', maxHeight:'92vh', overflowY:'auto', boxShadow:'0 8px 32px rgba(0,0,0,0.18)' }} onClick={e=>e.stopPropagation()}>
              <ModalHeader
                icon={isEditMode ? "ti-edit" : "ti-plus"}
                color={isEditMode ? COLORS.orange : COLORS.green}
                title={isEditMode ? "Edit Service" : "Add Service"}
                subtitle={isEditMode ? inpval.serviceName : "Fill in the service details below"}
                onClose={closeAdd}
              />
              <div style={{ padding:'0 24px 24px' }}>

                {/* Row 1 */}
                <FormRow>
                  <FormField label="Service Code">
                    <input name="serviceCode" value={inpval.serviceCode} onChange={handlechange} placeholder="Code" style={formInput} />
                  </FormField>
                  <FormField label="Service Name">
                    <input name="serviceName" value={inpval.serviceName} onChange={handlechange} placeholder="Name" style={formInput} />
                  </FormField>
                  <FormField label="Category">
                    <select name="category" value={inpval.category} onChange={handlechange} style={formSelect}>
                      <option value="">Select</option>
                      {patients1.map(item => <option key={item.id} value={item.id}>{item.category_name}</option>)}
                    </select>
                  </FormField>
                  <FormField label="Duration (min)">
                    <select name="durationMinutes" value={inpval.durationMinutes} onChange={handlechange} style={formSelect}>
                      <option value="">Select</option>
                      {[5,10,15,20,30,45,60].map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                  </FormField>
                </FormRow>

                {/* Row 2 */}
                <FormRow>
                  <FormField label="Standard Cost">
                    <input type="number" name="standardCost" value={inpval.standardCost} onChange={handlechange} placeholder="0.000" step="0.001" style={formInput} />
                    {fieldErrors.standardCost && <div style={{ fontSize:11, color:COLORS.red, marginTop:3 }}>{fieldErrors.standardCost}</div>}
                  </FormField>
                  <FormField label="Secondary Cost">
                    <input type="number" name="secondaryCost" value={inpval.secondaryCost} onChange={handlechange} placeholder="0.000" step="0.001" style={formInput} />
                    {fieldErrors.secondaryCost && <div style={{ fontSize:11, color:COLORS.red, marginTop:3 }}>{fieldErrors.secondaryCost}</div>}
                  </FormField>
                  <FormField label="Insurance Cost">
                    <input type="number" name="insuranceCost" value={inpval.insuranceCost} onChange={handlechange} placeholder="0.000" step="0.001" style={formInput} />
                    {fieldErrors.insuranceCost && <div style={{ fontSize:11, color:COLORS.red, marginTop:3 }}>{fieldErrors.insuranceCost}</div>}
                  </FormField>
                  <FormField label="VAT">
                    <select name="vat" value={inpval.vat} onChange={handlechange} style={formSelect}>
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </select>
                    {inpval.vat==="Yes" && <div style={{ fontSize:11, color:COLORS.gray, marginTop:3 }}>Applied: {vatValue}%</div>}
                  </FormField>
                </FormRow>

                {/* Row 3 */}
                <FormRow>
                  <FormField label="Description" style={{ flex:2 }}>
                    <input name="description" value={inpval.description} onChange={handlechange} placeholder="Description" style={formInput} />
                  </FormField>
                  <FormField label="Dental?">
                    <div style={{ display:'flex', alignItems:'center', gap:8, height:36 }}>
                      <input type="checkbox" id="isDental" checked={inpval.isDental != 0}
                        onChange={e => setInpval({...inpval, isDental:e.target.checked, dentalMode:e.target.checked?inpval.dentalMode:"single"})}
                        style={{ width:16, height:16, cursor:'pointer' }} />
                      <label htmlFor="isDental" style={{ fontSize:13, color:'#2d3748', cursor:'pointer' }}>Is Dental Service</label>
                    </div>
                  </FormField>
                  {inpval.isDental != 0 && <>
                    <FormField label="Dental Mode">
                      <select style={formSelect} value={inpval.dentalMode} onChange={e=>setInpval({...inpval,dentalMode:e.target.value})}>
                        <option value="single">Single (per tooth)</option>
                        <option value="multiple">Multiple (single price)</option>
                      </select>
                    </FormField>
                    <FormField label="Dental Type">
                      <select style={formSelect} value={inpval.dental_type} onChange={e=>setInpval({...inpval,dental_type:e.target.value})}>
                        {Object.keys(dentalMapping).map(m => <option key={m} value={m}>{dentalMapping[m]}</option>)}
                      </select>
                    </FormField>
                  </>}
                </FormRow>

                {/* Inventory */}
                <div style={{ marginTop:16 }}>
                  <div style={{ ...labelStyle, marginBottom:8 }}>Linked Inventory Items</div>
                  <div style={{ display:'flex', gap:8, marginBottom:10 }}>
                    <div style={{ position:'relative', flex:1 }}>
                      <input type="text" placeholder="Search inventory item…" value={itemSearch}
                        onChange={e => { setItemSearch(e.target.value); setItemSelectId(""); setShowSuggestions(true); }}
                        onFocus={() => setShowSuggestions(true)}
                        onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
                        autoComplete="off" style={{ ...formInput, width:'100%' }} />
                      {showSuggestions && itemSearch.trim() !== "" && (
                        <ul style={{ position:'absolute', top:'100%', left:0, right:0, zIndex:1100, background:'#fff', border:'1px solid #e8ecf0', borderRadius:8, boxShadow:'0 4px 12px rgba(0,0,0,0.1)', maxHeight:200, overflowY:'auto', margin:0, padding:0, listStyle:'none' }}>
                          {inventoryList.filter(d => d.name.toLowerCase().includes(itemSearch.toLowerCase()) || (d.strength&&d.strength.toLowerCase().includes(itemSearch.toLowerCase()))).map(d => (
                            <li key={d.id} onMouseDown={() => { setItemSelectId(d.id); setItemSearch(`${d.name}${d.strength?` (${d.strength})`:""}`); setShowSuggestions(false); }}
                              style={{ padding:'7px 12px', fontSize:12, cursor:'pointer', borderBottom:'1px solid #f0f2f5' }}
                              onMouseEnter={e=>e.currentTarget.style.background='#f8f9fb'}
                              onMouseLeave={e=>e.currentTarget.style.background='#fff'}
                            >
                              {d.name}{d.strength?` (${d.strength})`:""} <span style={{ color:COLORS.gray }}>— Stock: {d.quantity}</span>
                            </li>
                          ))}
                          {inventoryList.filter(d=>d.name.toLowerCase().includes(itemSearch.toLowerCase())).length===0 && (
                            <li style={{ padding:'7px 12px', fontSize:12, color:COLORS.gray }}>No items found</li>
                          )}
                        </ul>
                      )}
                    </div>
                    <input type="number" min="0.001" step="0.001" value={itemSelectQty}
                      onChange={e=>setItemSelectQty(e.target.value)} placeholder="Qty"
                      style={{ ...formInput, width:80, textAlign:'center' }} />
                    <button type="button" onClick={addLinkedItem}
                      style={{ height:36, padding:'0 14px', borderRadius:8, border:`1.5px solid ${COLORS.green}`, background:`${COLORS.green}12`, color:COLORS.green, cursor:'pointer', fontWeight:700, fontSize:16 }}>+</button>
                  </div>
                  {linkedItems.length > 0 && (
                    <div style={{ borderRadius:8, border:'1px solid #e8ecf0', overflow:'hidden' }}>
                      <table style={{ width:'100%', borderCollapse:'collapse' }}>
                        <thead>
                          <tr>
                            <th style={thStyle}>Item</th>
                            <th style={thStyle}>Unit</th>
                            <th style={{ ...thStyle, width:120 }}>Qty Used</th>
                            <th style={{ ...thStyle, width:50 }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {linkedItems.map(item => (
                            <tr key={item.drug_id}>
                              <td style={tdStyle}>{item.drug_name}</td>
                              <td style={tdStyle}>{item.unit_of_measurement}</td>
                              <td style={tdStyle}>
                                <input type="number" min="0.001" step="0.001" value={item.quantity_used}
                                  onChange={e=>updateLinkedItemQty(item.drug_id,e.target.value)}
                                  style={{ ...formInput, width:'100%', height:30 }} />
                              </td>
                              <td style={{ ...tdStyle, textAlign:'center' }}>
                                <button type="button" onClick={()=>removeLinkedItem(item.drug_id)}
                                  style={{ width:26, height:26, borderRadius:6, border:'none', background:`${COLORS.red}15`, color:COLORS.red, cursor:'pointer', fontSize:13 }}>
                                  <i className="ti ti-trash" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {/* Consents */}
                <div style={{ marginTop:16 }}>
                  <div style={{ ...labelStyle, marginBottom:8 }}>Linked Consents</div>
                  <div style={{ position:'relative', marginBottom:8 }}>
                    <i className="ti ti-search" style={{ position:'absolute', left:9, top:'50%', transform:'translateY(-50%)', color:COLORS.gray, fontSize:13, pointerEvents:'none' }} />
                    <input
                      type="text"
                      placeholder="Filter consents..."
                      value={consentSearch}
                      onChange={e => setConsentSearch(e.target.value)}
                      style={{ ...formInput, paddingLeft:30 }}
                    />
                  </div>
                  {consentsList.length === 0 ? (
                    <div style={{ fontSize:12, color:COLORS.gray, padding:'8px 0' }}>No consent templates found.</div>
                  ) : (
                    <div style={{ borderRadius:8, border:'1px solid #e8ecf0', maxHeight:180, overflowY:'auto' }}>
                      {consentsList
                        .filter(c => c.name?.toLowerCase().includes(consentSearch.toLowerCase()))
                        .map((c, idx) => {
                          const checked = linkedConsentIds.includes(c.id);
                          return (
                            <label key={c.id} style={{
                              display:'flex', alignItems:'center', gap:10, padding:'8px 12px',
                              borderBottom: idx < consentsList.length - 1 ? '1px solid #f0f2f5' : 'none',
                              cursor:'pointer', fontSize:13, color:'#2d3748',
                              background: checked ? `${COLORS.blue}12` : 'transparent',
                            }}>
                              <input
                                type="checkbox"
                                checked={checked}
                                onChange={() => setLinkedConsentIds(prev =>
                                  checked ? prev.filter(id => id !== c.id) : [...prev, c.id]
                                )}
                                style={{ width:15, height:15, cursor:'pointer', accentColor: COLORS.blue }}
                              />
                              {c.name}
                            </label>
                          );
                        })
                      }
                    </div>
                  )}
                  {linkedConsentIds.length > 0 && (
                    <div style={{ fontSize:11, color:COLORS.blue, marginTop:5 }}>
                      {linkedConsentIds.length} consent{linkedConsentIds.length !== 1 ? 's' : ''} selected
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:20, paddingTop:16, borderTop:'1px solid #f0f2f5' }}>
                  <button onClick={closeAdd} style={{ padding:'8px 20px', fontSize:13, borderRadius:8, border:'1px solid #dde3eb', background:'#f8f9fb', color:COLORS.gray, cursor:'pointer' }}>Cancel</button>
                  <button onClick={handlesavevital123} className="bgBtn btn-sm" style={{ padding:'8px 20px', fontSize:13 }}>
                    {isEditMode ? "Update Service" : "Add Service"}
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

/* ── Helper sub-components ── */

function ActionBtn({ icon, color, title, onClick }) {
  return (
    <button onClick={onClick} title={title} style={{
      width:28, height:28, borderRadius:7, border:'none', cursor:'pointer',
      background:`${color}18`, color, display:'flex', alignItems:'center', justifyContent:'center', fontSize:14,
    }}
      onMouseEnter={e=>e.currentTarget.style.background=color+'33'}
      onMouseLeave={e=>e.currentTarget.style.background=color+'18'}
    ><i className={`ti ${icon}`} /></button>
  );
}

function ModalHeader({ icon, color, title, subtitle, onClose }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:10, padding:'16px 24px', borderBottom:'1px solid #e8ecf0', marginBottom:16 }}>
      <div style={{ width:34, height:34, borderRadius:8, background:`${color}20`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
        <i className={`ti ${icon}`} style={{ color, fontSize:17 }} />
      </div>
      <div>
        <div style={{ fontSize:14, fontWeight:700, color:'#1a202c' }}>{title}</div>
        {subtitle && <div style={{ fontSize:11, color:'#5B6B79' }}>{subtitle}</div>}
      </div>
      <button onClick={onClose} style={{ marginLeft:'auto', width:26, height:26, borderRadius:6, border:'1px solid #e8ecf0', background:'#f8f9fb', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'#5B6B79', fontSize:14 }}>
        <i className="ti ti-x" />
      </button>
    </div>
  );
}

function FormRow({ children }) {
  return <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:12 }}>{children}</div>;
}

function FormField({ label, children, style }) {
  return (
    <div style={{ flex:'1 1 180px', minWidth:140, ...style }}>
      <label style={{ fontSize:11, fontWeight:700, color:'#5B6B79', textTransform:'uppercase', letterSpacing:'0.05em', display:'block', marginBottom:4 }}>{label}</label>
      {children}
    </div>
  );
}

function ViewGrid({ label, value }) {
  return (
    <div style={{ display:'flex', alignItems:'flex-start', padding:'7px 0', borderBottom:'1px solid #f0f2f5', gap:12 }}>
      <span style={{ fontSize:11, fontWeight:700, color:'#5B6B79', textTransform:'uppercase', letterSpacing:'0.05em', minWidth:130, flexShrink:0 }}>{label}</span>
      <span style={{ fontSize:13, color:'#2d3748' }}>{value ?? '—'}</span>
    </div>
  );
}
